import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import {
  AdminBookEditorListRequest,
  AdminBookEditorMarketplaceReprocessRequest,
  AdminBookEditorMarketplaceToggleRequest,
  AdminBookEditorSaveRequest
} from '../../requests/platform/admin-book-editor.request';
import { AdminBookEditorEditResponse, AdminBookEditorMarketplaceResponse } from '../../responses/platform/admin-book-editor.response';
import { AdminReviewerBookResponse } from '../../responses/platform/admin-reviewer-book.response';

@Injectable({ providedIn: 'root' })
export class AdminBookEditorService extends CommonService {
  constructor(private http: HttpClient) { super(); }

  listBooks(req: AdminBookEditorListRequest): Observable<AdminReviewerBookResponse> {
    return this.http.post<AdminReviewerBookResponse>(
      `${environment.urlApiPlatform}AdminBookEditor/list`, req, this.addHeaderToken()
    ).pipe(catchError(this.handleError));
  }

  getBookForEdit(idBookVersion: number): Observable<AdminBookEditorEditResponse> {
    return this.http.get<AdminBookEditorEditResponse>(
      `${environment.urlApiPlatform}AdminBookEditor/idBookVersion/${idBookVersion}`, this.addHeaderToken()
    ).pipe(catchError(this.handleError));
  }

  saveEdit(request: AdminBookEditorSaveRequest): Observable<any> {
    return this.http.post<any>(
      `${environment.urlApiPlatform}AdminBookEditor/save-edit`, request, this.addHeaderToken()
    ).pipe(catchError(this.handleError));
  }

  /** Liga/desliga "Liberado para marketplace" (publicação na Amazon). */
  toggleMarketplace(request: AdminBookEditorMarketplaceToggleRequest): Observable<AdminBookEditorMarketplaceResponse> {
    return this.http.post<AdminBookEditorMarketplaceResponse>(
      `${environment.urlApiPlatform}AdminBookEditor/marketplace/toggle`, request, this.addHeaderToken()
    ).pipe(catchError(this.handleError));
  }

  /** Reenvia para publicação anúncio que ficou com erro. */
  reprocessMarketplace(request: AdminBookEditorMarketplaceReprocessRequest): Observable<AdminBookEditorMarketplaceResponse> {
    return this.http.post<AdminBookEditorMarketplaceResponse>(
      `${environment.urlApiPlatform}AdminBookEditor/marketplace/reprocess`, request, this.addHeaderToken()
    ).pipe(catchError(this.handleError));
  }
}
